/*
 * Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
 * Venelin Iliev <http://veneliniliev.com>
 */

import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { Subject } from 'rxjs';
import { ApiQuery } from '@app/core/http/api-query';
import { FormGroup } from '@angular/forms';
import { PaginatedResponse } from '@app/shared/models/paginated-response.model';
import { Logger } from '@app/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { RolesService } from '@app/settings/users/roles/roles.service';
import { UserRole } from '@app/settings/users/roles/user-role.model';

const log = new Logger('RoleSelectComponent');

@UntilDestroy()
@Component({
  selector: 'app-role-select',
  templateUrl: './role-select.component.html',
  styleUrls: ['./role-select.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RoleSelectComponent implements OnInit {
  data: Array<UserRole>;
  apiQuery: ApiQuery = new ApiQuery();
  loader: boolean;
  @Input() parentFormGroup: FormGroup;
  @Input() hideLabel = false;
  @Input() onlyActive = true;
  @Output() select = new EventEmitter();
  input$ = new Subject<string>();
  @Input() includes: string = null;

  @Input() passFormControlName = 'role_id';
  companyFormControlName: any = this.passFormControlName.replace('_id', '');

  constructor(private rolesService: RolesService, private cdr: ChangeDetectorRef) {}

  ngOnInit() {
    this.companyFormControlName = this.passFormControlName.replace('_id', '');

    // #69
    this.loadRoles();

    // const preSelectedCompany = this.parentFormGroup.get('company');
    // const preSelectedCompanyId = this.parentFormGroup.get('company_id');

    /**
     * Попълва избрания хотел на едит.
     * Ако има FormControl 'company' в parentFormGroup.
     * Ако няма ще се опита да го get-не по ID
     */
    // if (preSelectedCompany) {
    //   log.debug('preSelectedCompany', preSelectedCompany);
    //   /*
    //    * Следи за промени в company FormControl-a и когато намери валиден Company спира да следи
    //    */
    //   const preselectedCompanySubscriber = preSelectedCompany.valueChanges.subscribe((company: any) => {
    //     if (company && company.name) {
    //       log.debug('set', company);
    //       this.data = [company];
    //       preselectedCompanySubscriber.unsubscribe();
    //     }
    //   });
    // }
    // else if (preSelectedCompanyId) {
    //   log.debug('preSelectedCompanyId', preSelectedCompanyId);
    //   /*
    //    * Ако не е намерен company FormControl-a търси company_id FormControl и се опитва да get-не company-то по ID
    //    */
    //   const preselectedCompanyIdSubscriber = preSelectedCompanyId.valueChanges.subscribe((companyId: any) => {
    //     if (companyId) {
    //       this.loadCompanyById(companyId);
    //       preselectedCompanyIdSubscriber.unsubscribe();
    //     }
    //   });
    // }

    // this.companySearch();
  }

  loadRoles(keyword?: string) {
    log.debug('loadRoles');

    this.loader = true;

    if (this.onlyActive) {
      this.apiQuery.addFilters({ active: true });
    }

    if (this.includes) {
      this.apiQuery.addIncludes(this.includes);
    }

    this.rolesService
      .index(this.apiQuery.setLimit(9999))
      .pipe(untilDestroyed(this))
      .subscribe((response: PaginatedResponse) => {
        this.data = response.data;
        this.loader = false;
        this.cdr.markForCheck();
      });
  }

  // loadCompanyById(id: number) {
  //   this.loader = true;
  //   this.companyService.show(id).subscribe((company: Company) => {
  //     this.data = [company];
  //     this.loader = false;
  //   });
  // }

  // companySearch() {
  //   this.input$
  //     .pipe(
  //       tap(() => (this.loader = true)),
  //       debounceTime(1000),
  //       distinctUntilChanged(),
  //       switchMap(term =>
  //         this.companyService.index(this.apiQuery.setLimit(9999).addFilter('name', term)).pipe(
  //           catchError(() => of([])), // empty list on error
  //           tap(() => (this.loader = false))
  //         )
  //       )
  //     )
  //     .subscribe((companies: PaginatedResponse) => {
  //       this.data = companies.data;
  //       this.loader = false;
  //     });
  // }

  onChange(company: any) {
    this.select.emit(company);

    if (this.parentFormGroup.get(this.companyFormControlName)) {
      this.parentFormGroup.get(this.companyFormControlName).patchValue(company || null);
    }
  }

  // add(searchTerm: string) {
  //   this.companyFormService.open(new Company().deserialize({ name: searchTerm })).then(
  //     (response) => {
  //       this.loadCompanies();
  //       this.parentFormGroup.get(this.passFormControlName).setValue(response.id);
  //     },
  //     (err) => {
  //       log.error(err);
  //     }
  //   );
  // }

  // edit() {
  //   if (this.parentFormGroup.get(this.passFormControlName).value) {
  //     this.companyFormService
  //       .open(new Company().deserialize({ id: this.parentFormGroup.get(this.passFormControlName).value }))
  //       .then(
  //         (response) => {
  //           this.loadCompanies(); // @todo: като стигне до тук вече е кеширано, така че трябва да се измисли друго
  //           this.parentFormGroup.get(this.passFormControlName).setValue(response.id);
  //           if (this.parentFormGroup.get(this.companyFormControlName)) {
  //             this.parentFormGroup.get(this.companyFormControlName).patchValue(response);
  //           }
  //         },
  //         (err) => {
  //           log.error(err);
  //         }
  //       );
  //   }
  // }
  search(term: string, item: UserRole): boolean {
    return item.name.toLowerCase().includes(term.toLowerCase());
  }
}
